export const trading = {
  kpsj: "Heure d'ouverture",
  jlks: "Temps avant le début",
  t: "jours",
  s: "heures",
  f: "minutes",
  m: "secondes",

  zgj: "Plus haut :",
  zdj: "Plus bas :",
  gflj: "Lien officiel",
  gw: "Site officiel",
  qkllq: "Explorateur de blocs",
  scfxsj: "Date de première émission",
  fxzl: "Émission totale",
  ltzl: "Circulation totale",
  jy: "Trader",
  sj: "Prix du marché",
  tbxx: "Info graphique",
  bzgk: "Aperçu de la devise",
  jcb: "Version basique",
  ddb: "Tableau des ordres",
  zxcj: "Dernière transaction",

  reload: "Actualiser",
  socketError: "Erreur réseau, veuillez",
  noData: "Aucune donnée",
  entrustorder: "Carnet d'ordres",
  prices: "Prix",
  quantity: "Quantité",
  grandtotal: "Cumulé",
  transamount: "Volume",
  time: "Temps",
  available: "Disponible",
  limitorder: "Limite",
  plancommission: "Ordre planifié",
  currentcommission: "Ordre en cours",
  historycommission: "Historique des ordres",
  completecommission: "Ordres exécutés",
  funds: "Fonds",
  hidetrading: "Masquer les autres paires",
  morecurrentcommission: "Plus d'ordres en cours",
  morehistorycommission: "Plus d'historique",
  moredocommission: "Plus d'exécutés",
  realtimetrans: "Transactions temps réel",
  myassets: "Mes actifs",
  detail: "Détails",
  buyin: "Acheter",
  sellout: "Vendre",
  login: "Connexion",
  transfer: "Transfert",
  recharge: "Dépôt",
  withdrawal: "Acheter",
  quickpurchase: "Achat rapide fiat",
  default: "Par défaut",
  ordertime: "Heure de l'ordre",
  tradingpair: "Paire de trading",
  direction: "Direction",
  types: "Type",
  commissionprice: "Prix de l'ordre",
  commissionnumber: "Quantité de l'ordre",
  dealprice: "Prix moyen d'exécution",
  dealnumber: "Quantité exécutée",
  triggerprice: "Prix de déclenchement",
  cancelall: "Tout annuler",
  averageprice: "Prix moyen",
  totalsum: "Total",
  fixedprice: "Limite",
  marketprice: "Marché",
  codeExpired: "QR code expiré",
  clickRefresh: "Cliquez pour actualiser",
  QRsuccessfully: "Scan réussi",
  loginInApp: "Veuillez confirmer dans l'APP",
  backtoQR: "Retour au QR code",
  loginSuccess: "Connexion réussie, bienvenue sur Biking !",
  loadingText: "Chargement...",
  searchPlaceholder: "Rechercher",
  all: "Tout",
  currency: "Devise",
  price: "Dernier prix",
  market: "Classement des gains",
  increase: "Variation",
  highestPrice: "Plus haut",
  minimumPrice: "Plus bas",
  turnover: "Volume",
  jydlb: "Liste des paires",
  bzjs: "Présentation de la devise",
  currencyTransaction: "Trading spot",
  leveragedTransaction: "Trading à effet de levier",
  warning:
    "Avertissement : Le fork de Bitcoin Cash comporte une grande incertitude. Trader des tokens fork期货comporte de grands risques. Si une chaîne manque de支持minier, elle pourrait ne pas survivre. BiKing ne fait aucune promesse sur la valeur des tokens fork !",
  zb: "Indicateur",
  date: "Temps",
  UpAnddown: "Hausse/Baisse",
  amplitude: "Amplitude",
  0: "1 min",
  1: "1 minute",
  5: "5 minutes",
  15: "15 minutes",
  30: "30 minutes",
  60: "1 heure",
  240: "4 heures",
  3600: "1 jour",
  10800: "1 semaine",
  dates: "Période :",
  password: "Mot de passe de trading",
  errorPassword: "Veuillez entrer un mot de passe valide",
  worningPassword: "Veuillez entrer le mot de passe de trading",
  cancel: "Annuler",
  sure: "Confirmer",
  canBuy: "Peut acheter",
  canCell: "Peut vendre",
  withdraw: "Retirer",
  otc: "OTC, entrée/sortie fiat rapide",
  enterPrice: "Veuillez entrer le prix",
  sellingPrice: "Prix de vente",
  purchasePrice: "Prix d'achat",
  salesVolume: "Volume de vente",
  buyingVolume: "Volume d'achat",
  volume: "Volume",
  serviceCharge: "Frais",
  vip: "Passer VIP pour des frais réduits",
  or: "Ou",
  register: "S'inscrire",
  totalPrice: "Le volume ne peut pas dépasser",
  amountTip: "Veuillez entrer une quantité valide",
  amountTipError: "La quantité ne peut pas dépasser",
  limitTrading: "Trading à limite",
  priceReminder: "Alerte de prix",
  SMSReminder: "Alerte SMS",
  loginAccount: "Compte",
  phone: "Téléphone",
  phoneNum: "Veuillez entrer le téléphone",
  phoneTips: "Veuillez entrer un téléphone valide",
  email: "Email",
  emailNum: "Veuillez entrer l'email",
  emailTips: "Veuillez entrer un email valide",
  aears: "Veuillez sélectionner l'indicatif",
  passwordError: "Veuillez entrer un mot de passe valide",
  passwordTips: "Veuillez entrer le mot de passe",
  forgetPassword: "Mot de passe oublié",
  noAccount: "Pas de compte",
  goRegister: "S'inscrire maintenant",
  appsys: "Scanner l'APP pour connexion sécurisée",
  xzapp: "Télécharger la dernière APP",
  mmdl: "Connexion par mot de passe",
  smdl: "Connexion par QR",
  google: "Google Authenticator",
  nybd: "Vous avez lié",
  zqyzm: "Veuillez entrer un code valide",
  fsyzm: "Envoyer le code",
  flv: "Taux",
  jz: "Valeur nette",
  jzdesc1:
    "Valeur nette long = Valeur nette précédente * [1 + 3 * (Prix spot actuel - Prix spot précédent) / Prix spot précédent * 100%] ;",
  jzdesc2:
    "Valeur nette short = Valeur nette précédente * [1 - 3 * (Prix spot actuel - Prix spot précédent) / Prix spot précédent * 100%] ;",
  sbd: "3x Long",
  sbs: "3x Short",
  flvjs:
    'Le taux de funding ETF est les frais de gestion quotidiens prélevés par la plateforme pour payer les frais de funding du fonds. Ces frais sont reflétés dans la valeur nette.',
  mzsm: "Avertissement",
  ido: "J'ai lu et j'accepte",
  exemption1: "Cher client, bonjour !",
  exemption2:
    "Merci d'utiliser les produits ETF et services Biking. Veuillez lire attentivement les说明et les risques. En continuant, vous acceptez les risques.",
  exemption3: "FAQ des produits ETF à levier",
  exemption4: "Avertissement de risque :",
  exemption5:
    "1. Le prix d'achat/vente ne devrait pas s'écarter beaucoup de la valeur nette, sinon vous	subirez des pertes.",
  exemption6: "2. En cas d'erreur de direction, dans des conditions extrêmes, le prix peut趋近zéro.",
  exemption7:
    "Biking vous提醒que les pertes dues aux risques ci-dessus sont à votre charge. Cet avertissement fait partie de l'accord complet.",
  bzjs1: "1. '3L' signifie que si le prix augmente de 1%, la valeur nette augmente de 3%",
  bzjs2: "2. '3S' signifie que si le prix baisse de 1%, la valeur nette augmente de 3%",
  bzjs3: "3. La valeur nette est ajustée quotidiennement à 0h",
  bzjs4: "4. Des frais de gestion sont prélevés quotidiennement",
  bzjs5:
    "5. Veuillez vérifier la valeur nette avant de trader. Dans des conditions extrêmes, le prix peut趋近zéro.",
  gdjk: "Plus de détails dans les annonces",
  firstTrading: "Avant le premier trade, Veuillez définir un mot de passe de trading",
  status: "Statut",
  status1: "En attente",
  status2: "Non exécuté",
  status3: "Annulé par l'utilisateur",
  status4: "Partiellement exécuté",
  status5: "Entièrement exécuté",
  status6: "Invalide",
  allCancel: "Annuler tous les ordres",
  canceld: "Annuler",
  cancelsuccess: "Tous annulés, [*] ordres annulés",
  VIP1: "Votre niveau VIP",
  VIP2: "Frais réduits et meilleure expérience",
  VIP3: "Taker :",
  VIP4: "Maker :",
  buyAmount: "La quantité d'achat ne peut pas dépasser",
  sellAmount: "La quantité de vente ne peut pas dépasser",
  buyAmountMin: "Votre solde disponible est insuffisant",
  sellAmountMin: "Votre solde vendable est insuffisant",

};


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/fr.js